<div class="work-ui-burger-menu-icon">
  <label for="burger-menu-toggle" data-testid="burger-menu-toggle">
    <input (click)="emitToggle()" [checked]="show" id="burger-menu-toggle" type="checkbox" />
    <span></span>
    <span></span>
    <span></span>
  </label>
</div>
